import { Route } from '../../config/router'

export const Breadcrumbs: Partial<Record<Route, string>> = {
  [Route.UPCOMING_PAYMENTS]: 'upcomingPayments',
  [Route.ORDERS]: 'orders',
  [Route.ORDER]: 'orders',
  [Route.ACCOUNT]: 'account',
  [Route.RECURRING_PAYMENTS]: 'recurringPayments',
}
